// Enable preact debug toolbar and module hot replacement
if (module.hot) {
    require("preact/debug");
    module.hot.accept();
}

// Add styles and icons
import "./css/screen-v6.scss";
//import './icons.svg';

// load polyfills and run script core
import { load_required_polyfills } from "./utils/polyfills";

// Add core components
import render_widgets from "./utils/render_widgets";
// import FloatingBarsController from "/components/FloatingBars/FloatingBarsController";
import ActionBar from "./components/Quote/ActionBar";
// import CookieBar from "/components/CookieBar/CookieBar";
import Readmore from "./components/Readmore/Readmore";

// vanilla
import { init_adsense_lazy_load } from "./utils/ads";
import { init_img_lazyload } from "./vanilla/lazyload";
import { init_add_link_to_clipboard } from "./vanilla/clipboard";
import { init_share_popup } from "./vanilla/share-popup";
import { init_infinite_scroll } from "./vanilla/infinite-scroll";

// utils
import { readCookie, setCookie } from "./utils/cookies";
import { prevent_double_submit, dropdown_init } from "./utils/forms";
import { push_ga_event } from "./utils/ga";
import lazy_component from "./utils/lazy_component";

load_required_polyfills(function () {
    document.render_widgets = render_widgets({
        // FloatingBarsController,
        ActionBar,
        // CookieBar,
        Readmore,

        // lazy loaded widgets
        // MultipleNote: lazy_component(() => import("./components/Form/MultipleNote")),
        // QuoteContent: lazy_component(() => import("./components/Form/QuoteContent")),
        // AuthorSelect: lazy_component(() => import("./components/Form/AuthorSelect")),
    });

    // Add Vanilla JS modules
    init_adsense_lazy_load(document);
    init_img_lazyload();
    init_infinite_scroll();
    init_add_link_to_clipboard();
    init_share_popup();

    // Publish utils functions
    window.utils = {};
    window.utils.readCookie = readCookie;
    window.utils.setCookie = setCookie;
    window.utils.prevent_double_submit = prevent_double_submit;
    window.utils.dropdown_init = dropdown_init;
    window.utils.push_ga_event = push_ga_event;
});
